module.exports = __webpack_public_path__ + "static/1-fba47291de9427105594d5cc6d9f5675.jpg";